// src/firbase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithEmailAndPassword, signInWithPopup, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDvH9J5Vv1WAY7x3PqdIj_znjURyVGXGt4",
    authDomain: "mind-loop-gpt.firebaseapp.com",
    projectId: "mind-loop-gpt",
    storageBucket: "mind-loop-gpt.appspot.com",
    messagingSenderId: "666687474185",
    appId: "1:666687474185:web:7f0aa7103586427982c6d8",
    measurementId: "G-YQ0HYYFB1M"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, provider, signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword, db };
